import { Box, Button } from "@mui/material";

interface CustomPaginationProps {
  totalPages?: number;
  currentPage?: number;
  onPageChange?: (page: number) => void;
}

const CustomPagination = ({
  totalPages = 4,
  currentPage = 0,
  onPageChange = () => {},
}: CustomPaginationProps) => {
  const fixedPages = [0, 1, 2, 3]; // Static first 4 page buttons

  return (
      <div className="pagination">
        <p>Showing <strong> 1-10</strong> from  <strong> 46 </strong>data</p>
    <Box display="flex" alignItems="center" >
      <Button 
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 0}
        className="page-btn"
      >
       <img src="/static/images/pagination_arrow.svg" alt="icon" />
      </Button>

      <div className="count_page">
        {fixedPages.map((pageIndex) => (
          <Button
            key={pageIndex}
            variant={currentPage === pageIndex ? "contained" : "outlined"}
            onClick={() => onPageChange(pageIndex)}
            className={`page-btn ${currentPage === pageIndex ? "active" : ""}`}
           
          >
            {pageIndex + 1}
          </Button>
        ))}
      </div>

      <Button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages - 1}
        className="page-btn"
      >
        <img src="/static/images/pagination_arrow.svg" alt="icon" />
      </Button>
    </Box>
    </div>
  );
};

export default CustomPagination;
